@if (userService.currentUser) {
  <div class="user-content-div table">
    <div id="username" class="cell">{{formatUtil.formatName(userService.currentUser.FirstName,
    userService.currentUser.LastName)}}</div>
    <span id="chevron-down" class="cell" [matMenuTriggerFor]="ctxMenu" (menuOpened)="expendMenu(true)"
      (menuClosed)="expendMenu(false)">
      <img [class.expended]="this.isMenuExpended" [class.collapsed]="!this.isMenuExpended"
        src="assets/images/chevron-down-black-grey-border-grey-fill.svg" alt="Expand logout menu">
      </span>
      <mat-menu #ctxMenu="matMenu" xPosition="before" backdropClass="header-menu-backdrop">
        <div class="user">{{formatUtil.formatName(userService.currentUser.FirstName, userService.currentUser.LastName)}}
        </div>
        <button mat-menu-item (click)="signOut()">Sign out</button>
      </mat-menu>
    </div>
  }